// extracted by mini-css-extract-plugin
export default {"commentForm":"CommentForm_commentForm__1HfrK","buttonComment":"CommentForm_buttonComment__jxML3"};